import { useLang } from 'hooks/lang';

import { Alert, Column, Label, RadioInput, Row } from 'components/Blocks';

import { REPRICE_REASONS } from 'utils/constants';

interface ReasonSelectProps {
  children?: never;
  reason: string | null;
  setReason(r: string | null): void;
}

export function ReasonSelect({ reason, setReason }: ReasonSelectProps) {
  const { t } = useLang();

  return (
    <Column>
      <Label>{t('why-cost-change-necessary')}</Label>

      <RadioInput
        alignItems="flex-start"
        size="small"
        className="w-full rounded-md border p-2 px-4 text-start text-sm hover:text-primary"
        value={reason || ''}
        onChangeDirect={setReason}
        options={REPRICE_REASONS.map(({ getLabel, ...config }) => ({
          ...config,
          label: getLabel(t),
        }))}
        render={({ icon: Icon, label, getDescription }) => (
          <Row gap="2" alignItems="flex-start">
            <Icon size={16} className="mt-1" />

            <Column gap="1">
              {label}
              <span className="text-xs text-muted-foreground opacity-50">{getDescription(t)}</span>
            </Column>
          </Row>
        )}
      />

      <Alert level="warning">{t('cost-change-reason-warning')}</Alert>
    </Column>
  );
}
